export const AGGREGATION_TYPE = {
    AGGREGATED: 'AGGREGATED',
    LAST_VALUE: 'LAST_VALUE',
};
